export default __webpack_public_path__ + "static/text-d9c25d8de7d9a2c2710176462c1caa2f.svg";